import {Mapper} from '@s-ui/domain'

export class FromPageNameToConstantNamingPageName extends Mapper {
  map = pageName => {
    return pageName?.replace(/-/g, '_').toUpperCase()
  }
}
